import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// [获取充值额外奖励列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127581584
export const socialize_recharge_extra_list = createAsyncThunk(
  '/live/pay/socialize_recharge_extra_list',
  async (arg: any, store) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/pay/socialize_recharge_extra_list',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

interface RewardInfo {
  icon: string
  title: string
  count: number
  worth: number
}

interface ExtraInfo {
  title: string
  rewards: RewardInfo[]
}
export interface InitialStateType {
  list: ExtraInfo[]
}
const initialState: InitialStateType = {
  list: [],
}

export const Wallet2RechargeExtraSlice = createSlice({
  name: 'Wallet2RechargeExtra',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      socialize_recharge_extra_list.fulfilled,
      (state, action) => {
        // const {treasure_box_list: list} = action.payload
        Object.assign(state, {
          ...action.payload,
        })
      }
    )
  },
})
export default Wallet2RechargeExtraSlice.reducer
export const Wallet2RechargeExtraActions = Wallet2RechargeExtraSlice.actions
